const DAY = 86400000;
export const PEOPLE_DATE_ROLES = new Set(['owner','coo','cfo','leadership','district_leader','boutique_manager','recruiter','onboarding_admin']);
export function dateKey(value = new Date()) {
  if (typeof value === 'string') return value.slice(0,10);
  return `${value.getFullYear()}-${String(value.getMonth()+1).padStart(2,'0')}-${String(value.getDate()).padStart(2,'0')}`;
}
export function parseRosterDate(value) {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}(?:$|T)/.test(value)) return null;
  const key=value.slice(0,10), date=new Date(`${key}T12:00:00Z`);
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0,10)===key ? date : null;
}
export function formatRosterDate(value) {
  const date=parseRosterDate(value);
  return date ? date.toLocaleDateString(undefined,{month:'long',day:'numeric',year:'numeric',timeZone:'UTC'}) : 'Not recorded';
}
export function tenureLabel(employee, today = dateKey()) {
  const hire=parseRosterDate(employee.hire_date), now=parseRosterDate(today);
  if(!hire || !now || hire>now) return 'Tenure not recorded';
  const days=Math.round((now-hire)/DAY);
  if(days<30) return `${days} ${days===1?'day':'days'} with the team`;
  const months=(now.getUTCFullYear()-hire.getUTCFullYear())*12+now.getUTCMonth()-hire.getUTCMonth()-(now.getUTCDate()<hire.getUTCDate()?1:0);
  if(months<12) return `${Math.max(1,months)} ${months===1?'month':'months'} with the team`;
  const years=Math.floor(months/12), remaining=months%12;
  return `${years} ${years===1?'year':'years'}${remaining?`, ${remaining} ${remaining===1?'month':'months'}`:''} with the team`;
}
export function employeeMilestones(employee, today = dateKey(), horizon = 45) {
  const now=parseRosterDate(today);if(!now || employee.active===false)return [];
  const result=[], hire=parseRosterDate(employee.hire_date);
  if(hire) for(const days of [30,60,90]) {
    const date=new Date(hire.getTime()+days*DAY), until=Math.round((date-now)/DAY);
    if(until>=0 && until<=horizon) result.push({id:`${employee.user_id}-${days}`,employee,type:'review',label:`${days}-day review milestone`,date:date.toISOString().slice(0,10),daysAway:until});
  }
  const month=Number(employee.birthday_month), day=Number(employee.birthday_day);
  if(Number.isInteger(month)&&month>=1&&month<=12&&Number.isInteger(day)&&day>=1&&day<=31) {
    for(let year=now.getUTCFullYear();year<=now.getUTCFullYear()+4;year++) {
      const key=`${year}-${String(month).padStart(2,'0')}-${String(day).padStart(2,'0')}`, date=parseRosterDate(key);
      if(!date||date<now)continue;
      const until=Math.round((date-now)/DAY);
      if(until<=horizon)result.push({id:`${employee.user_id}-birthday-${year}`,employee,type:'birthday',label:'Birthday',date:key,daysAway:until});
      break;
    }
  }
  return result.sort((a,b)=>a.date.localeCompare(b.date));
}
